enum NotificationType {
    SUCCESS,
    ERROR,
    WARNING,
    INFO,
    DEBUG
}

export default NotificationType;